import SiteSuperMenu from "./SiteSuperMenu";

export const instance = new SiteSuperMenu();

export default { instance };
